import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { EmptyPage } from 'shared/ui/empty-page'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

interface Props {
  onGoBack: () => void
  onRetry: () => void
}

export const DocumentState: FC<Props> = ({ onGoBack, onRetry }) => {
  const { t } = useTranslation()

  return (
    <main className={s.page}>
      <HeaderGoBack
        isFixed={false}
        variant="grey"
        buttonWhite
        onGoBack={onGoBack}
      >
        <h1 className="bold-16">{t('tourDetails.title')}</h1>
      </HeaderGoBack>
      <EmptyPage
        title={t('tourDocument.error')}
        subTitle={t('tourDocument.errorDescription')}
        buttonText={t('tourDocument.retry')}
        onClick={onRetry}
      />
    </main>
  )
}
